import React from 'react';
import Translation from '@s/Translation';
import FeeDisclosure from '@v/ticket-picker/containers/FeeDisclosure';

const DynamicTicketsHeader = () => {
  return (
    <div className="dynamic-tickets">
      <h4 className="dynamic-tickets__header">
        <Translation>{"checkout__tickets"}</Translation>
      </h4>
      <FeeDisclosure />
    </div>
  );
};

export default DynamicTicketsHeader;